import React from "react";
export default function FilterHeader({ onBack, onClearAll, }) {
    return (<div className="flex flex-col shrink-0">
      <div className={"flex items-center justify-between p-2"}>
        <button type="button" onClick={onBack} className="size-10 flex items-center justify-center" aria-label="Wstecz">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.5473 2L6 11.293V12.707L15.5473 22H17V20.586L8.17956 12L17 3.414V2H15.5473Z" fill="#02282C"/>
          </svg>
        </button>
        <button type="button" onClick={onClearAll} className="uppercase text-xs font-medium h-10 flex items-center px-3">
          Wyczyść wszystko
        </button>
      </div>
      <h2 className="text-xl font-semibold px-4 pb-4">Filtruj</h2>
    </div>);
}
